export enum OrderRecipientKind {
	Individual = 'Individual',
	Business = 'Business'
}